import React from 'react';
import { Navbar,Nav,Button,Form,FormControl } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import cv1 from './img/cv1.jpg' ;
import cv2 from './img/cv2.jpg' ;
import cv3 from './img/cv3.jpg' ;

import reactLogo from './assets/logo.svg';
import {Card,CardDeck } from 'react-bootstrap';
import Header from './header'
export  default class Models extends React.Component {
  
    render() {
      return (

<div>
<Header/>


<div style={{backgroundColor:"black"}}>
<br/><br/>
<div className="container" style={{color:"white"}} >
      <div className="  justify-content-center">
            <h1>Modèles gratuits</h1>
      <p>Choisissez un modèle que vous aimez et personnalisez-le en ligne</p>
<Form.Group controlId="formBasicEmail">
    <Form.Label>Search</Form.Label>
    <Form.Control type="email" placeholder="Saisissez un Type de portfolio/Cv.." />
    
  </Form.Group>
      </div>

    </div>
    <br/><br/>
</div><br/><br/>
<div className="container">
<CardDeck>
  <Card>
    <Card.Img variant="top" src={cv1} style={{height:"400px"}} />
    
    <Card.Footer>
    <a  href="/models/create_cv1">Model CV1</a>
    </Card.Footer>
  </Card>
  <Card>
    <Card.Img variant="top" src={cv2}  style={{height:"400px"}}/>
   
    <a  href="/models/create_cv2">Model CV2</a>
    
  </Card>
  <Card>
    <Card.Img variant="top" src={cv3}  style={{height:"400px"}}/>
   
    <Card.Footer>
      <a  href="/models/create_cv3">Model CV3</a>
    </Card.Footer>
  </Card>
</CardDeck>
<br/><br/>

<CardDeck>
  <Card>
    <Card.Img variant="top" src={cv1} style={{height:"400px"}} />
    
    <Card.Footer>
    <a  href="/models/create_portfolio1">Model Portfolio1</a>
    </Card.Footer>
  </Card>
  <Card>
    <Card.Img variant="top" src={cv2}  style={{height:"400px"}}/>
   
    <Card.Footer>
    <a  href="/models/create_portfolio2">Model Portfolio2</a>
    </Card.Footer>
  </Card>
  <Card>
    <Card.Img variant="top" src={cv3}  style={{height:"400px"}}/>
   
    <Card.Footer>
      <a  href="/models/create_cv3">Model Portfolio3</a>
    </Card.Footer>
  </Card>
</CardDeck>
</div>
<br/><br/>

</div>
      );}
}